"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftPurchaseLogToJSON = exports.NftPurchaseLogFromJSONTyped = exports.NftPurchaseLogFromJSON = void 0;
var _1 = require("./");
function NftPurchaseLogFromJSON(json) {
    return NftPurchaseLogFromJSONTyped(json, false);
}
exports.NftPurchaseLogFromJSON = NftPurchaseLogFromJSON;
function NftPurchaseLogFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'date': json['date'],
        'status': (0, _1.NftPurchaseStatusFromJSON)(json['status']),
    };
}
exports.NftPurchaseLogFromJSONTyped = NftPurchaseLogFromJSONTyped;
function NftPurchaseLogToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date': value.date,
        'status': (0, _1.NftPurchaseStatusToJSON)(value.status),
    };
}
exports.NftPurchaseLogToJSON = NftPurchaseLogToJSON;
